var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 168.59 148.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#505050;}.cls-2{fill:#9ca5ad;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vectors"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "148.04 147.28 20.55 147.28 20.55 46.68 84.3 0.78 148.04 46.68 148.04 147.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M148,148.06H20.55a.78.78,0,0,1-.78-.78V46.68a.77.77,0,0,1,.32-.63L83.84.15a.8.8,0,0,1,.91,0l63.74,45.9a.76.76,0,0,1,.33.63v100.6A.78.78,0,0,1,148,148.06ZM21.33,146.5H147.26V47.08L84.3,1.74l-63,45.34Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "84.3 0.78 84.29 0.78 84.29 0.78 84.29 0.78 0.78 60.91 5.16 67 84.29 10.02 84.3 0.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.16,67.78H5a.79.79,0,0,1-.51-.32L.15,61.37a.78.78,0,0,1,.17-1.09L83.84.15a.76.76,0,0,1,.81-.06.78.78,0,0,1,.4.49.78.78,0,0,1-.21.75.7.7,0,0,1-.16.13L1.87,61.09l3.47,4.82L83.84,9.39a.77.77,0,0,1,1.08.18.76.76,0,0,1-.17,1.08l-79.13,57A.79.79,0,0,1,5.16,67.78Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "84.29 0.78 84.29 0.78 167.81 60.91 163.42 67 84.29 10.02 84.29 0.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M163.42,67.78a.74.74,0,0,1-.45-.15l-79.13-57a.77.77,0,0,1-.18-1.08.78.78,0,0,1,1.09-.18l78.5,56.52,3.47-4.82L83.84,1.41l-.1-.08a.78.78,0,0,1,0-1.1.79.79,0,0,1,1-.07l83.49,60.12a.79.79,0,0,1,.32.51.8.8,0,0,1-.14.58l-4.38,6.08a.82.82,0,0,1-.51.32Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "107.28 67.05 107.28 78.39 103.6 78.39 65.29 78.39 61.31 78.39 61.31 67.05 72.95 67.05 95.94 67.05 107.28 67.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M103.6,78.39v23a19.31,19.31,0,1,1-38.61,0v-23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73,68.89a2,2,0,0,1-1.84-1.84v-23a1.84,1.84,0,1,1,3.67,0v23A2,2,0,0,1,73,68.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M95.94,68.89a2,2,0,0,1-1.84-1.84v-23a1.84,1.84,0,1,1,3.68,0v23A2,2,0,0,1,95.94,68.89Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 81.32,
    y: 117.95,
    width: 5.95,
    height: 30.11
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home_icon.1dd13a107a73dd9de0f74fd32a4d3b56.svg";
export { ForwardRef as ReactComponent };